import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { LIMITS } from "@constants";
import { useCallback } from "react";


const OnBoardBg = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: space-between;
  background: url(${(props) => props.img}) no-repeat;
  background-size: cover;
  height: 100vh;
`;

const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 32px;
`;

const NavLink = styled(Link)`
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  margin-right: 16px;
`;


const OnBoarding = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const { splash_ads } = useSelector((state) => state.app.settings);
  // const [selectedIndex, setSelectedIndex] = useState(0);
  const [counter, setCounter] = useState(LIMITS.ONBOARDING_SCREEN_TIMEOUT);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCounter((prevCounter) => prevCounter - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line
  }, []);

  const handleSkip = useCallback(() => {
    if (counter === 0) {
      navigate(isLoggedIn ? `/${PUBLIC_ROUTE.HOME}` : `/${PUBLIC_ROUTE.LOGIN}`);
    }
  }, [isLoggedIn, navigate, counter]);

  useEffect(() => {
    handleSkip();
  }, [handleSkip]);

  return (
    <>
      <Link to={splash_ads[0]?.url}>
        <OnBoardBg
          img={splash_ads[0]?.image}
        >
          <NavContainer>
            <NavLink
              to={isLoggedIn ? `/${PUBLIC_ROUTE.HOME}` : `/${PUBLIC_ROUTE.LOGIN}`}
            >
              {t("common.skip")} ({counter})
            </NavLink>
          </NavContainer>
        </OnBoardBg>
      </Link>
    </>

  );
};

export default OnBoarding;
